import Vue from 'vue';
import VueRouter from 'vue-router';
// import request from '@/utils/request';
import Cookies from 'js-cookie';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HelloWorld.vue'),
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/care-rules',
    name: 'CareRules',
    component: () => import('@/views/CareRules.vue'),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: '/petHealth',
    name: 'PetHealth',
    component: () => import('@/views/PetHealth.vue'),
    meta: {
      requireAuth: false,
    },
  },
  
  {
    path: '/ownerRigest',
    name: 'OwnerRigest',
    component: () => import('@/views/OwnerRigest.vue'),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: '/petRegist',
    name: 'PetRegist',
    component: () => import('@/views/PetRegist.vue'),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: '/ownerUpdate',
    name: 'OwnerUpdate',
    component: () => import('@/views/OwnerUpdate.vue'),
    meta: {
      requireAuth: false,
    },
  },
  
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },

  {
    path: '/setpassword',
    name: 'Setpassword',
    component: () => import('@/views/Password.vue'),
  },

  {
    path: '/resetpassword',
    name: 'Resetpassword',
    component: () => import('@/views/PasswordReset.vue'),
  },

  {
    path: '/forgot',
    name: 'Forgot',
    component: () => import('@/views/Forgot.vue'),
  },

  {
    path: '/board',
    name: 'Board',
    component: () => import('@/views/Board.vue'),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: '/myPets',
    name: 'MyPets',
    component: () => import('@/views/MyPets.vue'),
    meta: {
      requireAuth: true,
    },
  },

  {
    path: '/myPetHome',
    name: 'MyPetHome',
    component: () => import('@/views/MyPetHome.vue'),
    meta: {
      requireAuth: true,
    },
  },

  {
    path: '/manshonRegist',
    name: 'ManshonRegist',
    component: () => import('@/views/ManshonRegist.vue'),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: '/inquary',
    name: 'Inquary',
    component: () => import('@/views/Inquary.vue'),
    meta: {
      requireAuth: false,
    },
  },

  {
    path: '/homePage',
    name: 'HomePage',
    component: () => import('@/views/HomePage.vue'),
    meta: {
      requireAuth: false,
    },
  },

  // {
  //   path: '*',
  //   name: 'NotFound',
  //   component: () => import('@/views/NotFound.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  // const loginStatus = await request('isLogin');
  const token = Cookies.get('token');
  window.scrollTo(0, 0);
  if (to.matched.some((record) => record.meta.requireAuth)) {
    if (token) {
      next();
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
});

export default router;
